var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"outlined":"","value":_vm.field.default,"label":_vm.field.published_name,"dense":"","hint":_vm.field.hint,"disabled":_vm.isDisabled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }